import { Box, styled } from "@mui/material";

export const TableListItemStyled = styled('li')(({ theme }) => ({
    borderRadius: theme.typography.borderRadius.xxSmall,
    border: `1px solid ${theme.palette.grey[300]}`,
    background: theme.palette.background.paper,

    padding: `${theme.typography.generic.medium} ${theme.typography.generic.large}`,
    width: '100%',

    marginBottom: theme.typography.generic.xLarge,

    display: 'flex',
    flexDirection: 'column',

    gap: '0.725rem',
}));
export const TableListStyled = styled('ul')(({ theme }) => ({
    listStyleType: 'none',
}));
export const TableListItemRowStyled = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
}));
export const TableListItemCellStyled = styled(Box)(({ theme }) => ({}));
export const TableListItemLeftCellStyled = styled(Box)(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontSize: theme.typography.customFontSize.small,
    fontWeight: theme.typography.fontWeightSemiBold,
    lineHeight: theme.typography.customFontSize.large,
}));
export const TableListItemRightCellStyled = styled(Box)(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontSize: theme.typography.customFontSize.small,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: '140%',
}));